import React, { useState } from 'react';
import MasterPage from './MasterPage';
import readUrl from './commons'

const PharmaERP = () => {
    var aaa = readUrl();
    const [state, setState] = useState(aaa);
    return (
        <MasterPage state={state} >
        <>
            {/*<head>*/}
            {/*    <title>Best ERP Software for Pharmaceutical {loc} | Best Pharmaceutical ERP Software {loc} | Business Management Solutions - Tejaxo Software</title>*/}
            {/*    <meta name="description" content={`Tejaxo Software is a High Rated Pharmaceutical ERP Software ${loc} and BI software for Pharmaceutical Industries ${loc}, providing Barcode based automatic Production Enterprise Resource Planning (ERP) software ${loc}, business management solutions, services and support.`} />*/}
            {/*    <meta name="keywords" content={`Tejaxo Pharmaceutical ERP,Tejaxo Pharmaceutical ERP ${loc}, ERP Software for Pharmaceutical Industries`} />*/}
            {/*</head>*/}

            <section id="about" className="wow fadeInUp" style={{ backgroundColor: 'white' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 about-img">
                            <img src="/theme/img/pharmaceuticals-1-1024x683.jpg" alt="Pharmaceuticals" />
                        </div>
                            <div className="col-lg-6 content">
                                <h1 className="elementor-heading-title elementor-size-default">Pharmaceuticals Industry {state.condText}</h1>
                        </div>
                    </div>

                    <br />

                    <div className="row">
                        <div className="col-lg-6 about-img">
                            <h2 className="elementor-heading-title elementor-size-default">Constrained budgets, price pressure from generic products and increased regulatory pressures;</h2>
                            <p>
                                These are the dynamics that are forming a more competitive pharmaceuticals market and causing many operators to reassess their business models to ensure they remain responsive. There�s never been a better time; significant advancements in technology are opening the door to new efficiencies in business processes, from automated inventory management to easier ways to share information with joint venture partners and suppliers.
                            </p>
                        </div>
                        <div className="col-lg-6 content">
                            <img src="/theme/img/pharmaceuticals-2-768x512.jpg" alt="Pharmaceuticals 2" />
                        </div>
                    </div>

                    <br />

                    <div className="row">
                        <div className="col-lg-6 about-img">
                            <img src="/theme/img/bdimg4.JPG" alt="Tejaxo ERP" />
                        </div>
                        <div className="col-lg-6 content">
                            <h2 className="elementor-heading-title elementor-size-default">Tejaxo ERP provides all the tools pharmaceutical customers need to evolve and operate efficiently.</h2>
                            <p>
                                We embed global technological advancements into your business to give you a clear view of all aspects of your operation, and a tighter grasp on your financial performance. Tejaxo Software will partner with you in navigating the demands of your industry�those of your customers, regulators, and the community�while giving you the ability to quickly and easily share information with the people who need it, to ensure you stay completely in control.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            </>
        </MasterPage>
    );
};

export default PharmaERP;